<template>
  <div>
    <div class="text-center mt-4" v-if="Business">
      <img v-if="Business.imageUrl" height="50" :src="Business.imageUrl" alt="Logo" />

      <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
      <div v-if="Business.phoneNumber">
        {{ Business.phoneNumber | USPhoneNumber }}
      </div>
      <div>
        <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
        }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
        <span v-if="Business.zip">{{ Business.zip }}</span>
      </div>
    </div>
    <NewDonation :currentBusiness="Business" :takeCard="true"/>
  </div>
</template>

<script>
import applicationService from "@/modules/Application/service.js";
import NewDonation from "@/modules/Donation/components/NewDonation.vue"
export default {
  name: 'remote-application',
  components: {
    NewDonation
  },
  data() {
    return {
      Business: null,
    } 
  },
  created() {
    this.loadBusiness()
  },
  methods: {
    loadBusiness() {
      let id = this.$route.params.id;
      applicationService
        .getBusinessInformation({ key: id })
        .then((response) => {
          console.log("response", response);
          this.Business = response.data;
          // this.StripeKey = this.Business.metadata.publicStripeId;
          // this.Classes = this.Business.Classes;
        })
        .catch((error) => {
          console.log("error getting business", error);
          this.$router.push({ name: "pagenotfound" });
        });
    }
  }
  
}
</script>

<style scoped>
</style>